import axios from '@/helpers/http';

class AuthService {
  login_with_token(token) {
    if (localStorage.getItem('token') !== false) {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
    }
    return axios.post('giris', {
      token: token,
    }).then(response => {

      if (typeof response.data == 'object') {
        return response.data;
      } else {
        return false;
      }
    }).catch(error => {
      throw error;
    });
  }
  login(username, password) {
    return axios.post('login', {
      kullaniciAdi: username,
      sifre: password
    }).then(response => {

      if (typeof response.data == 'object') {
        return response.data;
      } else {
        return false;
      }
    }).catch(error => {
      throw error;
    });
  }
  incomplete_completion(student_id) {
    if (localStorage.getItem('token') !== false) {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
    }
    return axios.post('ogrenci-sinav-detay', {
      ogrenciID: student_id,
    }).then(response => {
      if (typeof response.data == 'object') {
        return response.data;
      } else {
        return false;
      }
    }).catch(error => {
      throw error;
    });
  }
  incomplete_completion_online(student_id) {
    if (localStorage.getItem('token') !== false) {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
    }
    return axios.post('eksik-tamamlama-online', {
      ogrenciID: student_id,
    }).then(response => {
      if (typeof response.data == 'object') {
        return response.data;
      } else {
        return false;
      }
    }).catch(error => {
      throw error;
    });
  }
  home_work(student_id) {
    if (localStorage.getItem('token') !== false) {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
    }
    return axios.post('ev-calismasi', {
      ogrenciID: student_id,
      durum: 'yeni'
    }).then(response => {
      if (typeof response.data == 'object') {
        return response.data;
      } else {
        return false;
      }
    }).catch(error => {
      throw error;
    });
  }
  old_home_work(student_id) {
    if (localStorage.getItem('token') !== false) {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
    }
    return axios.post('ev-calismasi', {
      ogrenciID: student_id,
      durum: 'eski'
    }).then(response => {
      if (typeof response.data == 'object') {
        return response.data;
      } else {
        return false;
      }
    }).catch(error => {
      throw error;
    });
  }
}
export default new AuthService();